/** «Финансы → Оплаты»: ответ ручки `/api/payment-reconcile`. */
import { apiFetch, query } from "@/lib/api";
import type { Money } from "@/lib/pnl";

/** Оплаты CRM: сумма по каналу (только ненулевые), число оплат, итоги. */
export type CrmSide = {
  crm: Record<string, Money>;
  count: number;
  crm_total: Money;
  /** Без наличных и переносов — то, что должно прийти в банк. */
  crm_cashless: Money;
};

/** Выручка по выпискам: сумма по статье; итог — без возвратов и инкассации. */
export type BankSide = {
  bank: Record<string, Money>;
  bank_total: Money;
  diff: Money;
  /** Разбор расхождения по причинам (только ненулевые); сумма = `diff`. */
  breakdown: Record<string, Money>;
};

export type ReconcileLocation = CrmSide & { id: number | null; name: string };

export type ReconcileRow = CrmSide &
  BankSide & { entrepreneur_id: number | null; name: string; locations: ReconcileLocation[] };

export type Reconcile = {
  date_from: string;
  date_to: string;
  channels: { code: string; name: string; cashless: boolean }[];
  bank_articles: { code: string; name: string; in_total: boolean }[];
  /** Строки разбора расхождения, в порядке показа. */
  lines: { code: string; name: string; hint: string }[];
  rows: ReconcileRow[];
  total: CrmSide & BankSide;
};

export function loadReconcile(filter: { date_from: string; date_to: string }): Promise<Reconcile> {
  return apiFetch<Reconcile>(`/api/payment-reconcile${query(filter)}`);
}
